import React from "react";
import PropTypes from "prop-types";

const TaskLink = ({ submissionWebUrl, integrationName }) => (
  <>
    <div>
      <a
        className="btn btn--default btn--small absolute-right"
        href={submissionWebUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        See Task on {integrationName}
      </a>
    </div>
  </>
);

TaskLink.propTypes = {
  submissionWebUrl: PropTypes.string,
  integrationName: PropTypes.string
};

export default TaskLink;
